import { recordLockMixin } from './recordLockMixin'

export const dispatchMixin = {
  methods: {
    async dispatch(route, loading) {
      let key = this.$store.state.commons.dispatch.key
      let data = this.$store.state.commons.dispatch.data

      this.$store.dispatch('dispatchClear')
      if (key === 'ReviewClaim') {
        await this.reviewClaim(data, route)
      } else if (key === 'QueryClaim') {
        await this.queryClaim(data)
      } else {
        this.$router.push({ name: route })
      }
    },
    async reviewClaim(data, route) {
      await this.checkRecordLock(data.clmNo, 'CLM').then(result => {
        if (!result) {
          this.performReview(data)
        } else {
          this.$router.push({ name: route })
        }
      })
    },
    async performReview(data) {
      const dispatchObj = {
        clmNo: data.clmNo,
        query: false
      }
      await this.$store.dispatch('loadClaim', dispatchObj)
      this.$router.push({ name: 'claimHeader' })
    },
    async queryClaim(data) {
      try {
        const dispatchObj = {
          clmNo: data.clmNo,
          remove: false,
          query: false
        }
        await this.$store.dispatch('loadClaim', dispatchObj)
        await this.$store.dispatch('claimEntryInit')
        await this.$store.dispatch('claimsRegisterInit')
        // Check status and redirect to the correct page
        this.$router.push({ name: 'qClaimHeader' })

        // Dont have to set loading to false here. It should have been redirected
        // If somehow error occurs, by right they cant try to load again. Might have dirty data now
        // this.loading = false
      } catch (err) {
        if (err.response && err.response.data) {
          this.fullMessage(err.response.data)
        } else if (err.message) {
          this.errorMessage(err.message)
        }
      }
    }
  },
  mixins: [
    recordLockMixin
  ]
}
